import { FC } from 'react';
import { MoreButton } from '../../buttons';
import styles from './booking-list-item.module.scss';

export type BookingListItemFooterProps = {
  bookingDetailsUrl: URL;
  tenantImageUrl: string;
  translations: {
    linkName: string;
  }
}

export const BookingListItemFooter: FC<BookingListItemFooterProps> = ({ bookingDetailsUrl, translations, tenantImageUrl }) => {
  return (
    <div className={styles.orderItemFooter}>
      <MoreButton url={bookingDetailsUrl}>{translations.linkName}</MoreButton>

      <div className={styles.tenantLogo}>
        <img src={tenantImageUrl} alt={'test'} />
      </div>
    </div>
  );
};
